<script>
  import router from '../../lib/router';
  import { polyfill_array_buffer } from '../../lib/utils';
  import Cropper from 'cropperjs';
  import * as R from 'ramda';
  import PhoneNumberFieldSettings from '../../forms/PhoneNumberFieldSettings.svelte';
  import { onMount, onDestroy } from 'svelte';
  import Selector from '../../lib/components/Selector.svelte';
  import CheckBox from '../../lib/components/CheckBox.svelte';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import settings from '../../config';
  import { TS } from '../../config/translation-keys.js';
  import { MDCDialog } from '@material/dialog';
  import { show_message } from '../../lib/flash.ts';
  import { compareStrings } from '../../lib/utils';
  import APIClient from '../../state-charts/api-client';
  import Messages from '../../lib/components/Messages.svelte';
  import Dialog from '../../lib/components/Dialog.svelte';
  import InputWithValidation from '../../lib/components/InputField.svelte';
  import { show_tutorial_screen } from '../../lib/tutorials';
  import Validators from '../../lib/validators';
  import ProfileInfo from './ProfileInfo';

  // component options  ------------------------------------------------------ //

  export let is_valid;
  export let input;
  export let validators;
  export let phone;
  export let is_first_time;
  export let is_ready;

  // internal variables  ------------------------------------------------------ //

  let old_password;
  let new_password;
  let new_password_confirm;
  let change_password_disabled = true;
  let dialog_change_password;
  const VALIDATION_DEBOUNCE_MS = 600;
  let email_debounce_timer;
  let password_debounce_timer;

  let tooltips_settings_language;
  let tooltips_settings_org_type;
  let tooltips_settings_order_desc;
  let tooltips_settings_worker_type;
  let tooltips_settings_worker_desc;
  let tooltips_settings_distance;

  let phone_field;
  let dialog_pic;
  let cropper;
  let has_pic_saved = false;
  let default_image = `/uploads/profile_images/default-avatar.jpg`;
  let labels = {}
  let org_type_clicked = false;


  let selectors = {
    language: [],
    organisation: null,
    worker_type: null,
    area_code: [],
  };

  let first_validator = {
    ssn: true,
    video: true,
    iban: true,
  };

  let input_errors = {
    email: null,
    password: null,
    new_password: null,
    new_password_confirm: null,
    first_name: null,
    last_name: null,
    tax: null,
    linkedin: null,
    iban: null,
    organization_type: null,
    company_name: null,
    registration_number: null,
    video: null,
    ssn: null,
  }

  // utility functions  ------------------------------------------------------ //

  const load_country_codes = () => {
    selectors.area_code = $session.api_config.phone_country_codes.map(item => {
      return { val: item.code, name: `(${item.country}) ${item.code}` };
    });
  };

  const init_profile_info = () => {
    polyfill_array_buffer();

    dialog_pic = new MDCDialog(document.getElementById(`pic-dialog`));
    dialog_change_password = new MDCDialog(
      document.getElementById(`change-password-dialog`),
    );
    dialog_change_password.scrimClickAction = '';
    dialog_change_password.escapeKeyAction = '';

    $session.tutorial = JSON.parse(window.localStorage.getItem('WP.tutorial'));
    show_tutorial_screen($session.tutorial, 'tour_w2', 400, $session.user.last_role)

    labels = ProfileInfo.translate_texts();
    init_selectors();
    load_country_codes();
    // init_event_listeners();
  };

  const rewatch_tutorial = async () => {
   // await APIClient.put_tutorial({"tutorials":["tour_w1", "tour_w2", "tour_w3", "tour_w4", "tour_w5", "tour_w6", "tour_w7", "tour_w8"]})
    await APIClient.put_tutorial({"tutorials":["intro"]})
    $session.tutorial = true;
    window.localStorage.setItem('WP.tutorial', $session.tutorial);
    // document.tutorial_reset = true
    show_tutorial_screen($session.tutorial, 'tour_w2', 400, $session.user.last_role, true)
  }

  const delete_account = async () => {
    const result = await APIClient.delete_account();
    router.navigate('/logout');
  };

  const open_delete_dialog = async () => {
    let target = document.querySelector('.delete-acc-dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'delete-acc-dialog',
        title: labels.delete_acc,
        content: t9n(TS.LABEL_ARE_YOU_SURE),
        modal: true,
        buttons: [
          {
            label: t9n(TS.TXT_CANCEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.LABEL_CONTINUE),
            action: async () => {
              await delete_account();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };

  const open_dialog_pic = () => {
    dialog_pic.open();

    let src = !!input.image_url ? input.image_url : default_image;

    let image = document.getElementById('imgpreview');

    if (!image) {
      let element = document.createElement('img');
      element.setAttribute('id', 'imgpreview');
      element.setAttribute('src', src);
      element.setAttribute('width', '600');
      let target = document.querySelector('#pic-dialog .mdc-dialog__content');
      target.append(element);
      image = element;
    }

    cropper = new Cropper(image, {
      viewMode: 3,
      aspectRatio: 1 / 1,
    });
  }

  const load_file = () => {
    let file = document.querySelector('input[type=file]').files[0];
    let reader = new FileReader();

    reader.onload = function() {
      if (file.size > 2097152) {
        show_message(labels.invalid_img, 'error');
      } else {
        cropper.replace(reader.result);
      }
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const open_upload_pic_dialog = () => {
    let elem = document.getElementById('input-button');
    if (elem && document.createEvent) {
      let evt = document.createEvent('MouseEvents');
      evt.initEvent('click', true, false);
      elem.dispatchEvent(evt);
    }
  };

  const close_dialog_pic = () => {
    dialog_pic.close();
    cropper.destroy();
    let element = document.querySelector(
      '#pic-dialog .mdc-dialog__content img',
    );
    element.remove();
  };

  const arrayBufferToBase64 = buffer => {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const save_profile_pic = () => {
    dialog_pic.close();
    let canvas = cropper.getCroppedCanvas();
    // input.profile_picture = canvas.toDataURL('image/jpeg', 0.5)
    // let b = canvas.toString();
    let base64 = canvas.toDataURL('image/jpeg', 0.5)
    base64 = base64.substring(base64.indexOf(",") + 1);
    input.profile_picture = base64;
    // console.log('todataurl', base64);
    // canvas.toBlob(blob => {
    //   blob.arrayBuffer().then(buffer => {
    //     input.profile_picture = arrayBufferToBase64(buffer);
    //     console.log('arraybuff', arrayBufferToBase64(buffer))
    //   });
    //   // input.profile_picture = URL.createObjectURL(blob);
    // });

    cropper.destroy();
    let element = document.querySelector(
      '#pic-dialog .mdc-dialog__content img',
    );
    element.remove();
    has_pic_saved = true;
  };

  const rotate_left = () => {
    cropper.rotate(-90);
  };

  const rotate_right = () => {
    cropper.rotate(90);
  };

  const init_selectors = () => {
    selectors.language = Object.entries(
      $session.api_config.supported_languages,
    ).map(lang => {
      return { val: lang[0], name: lang[1] };
    });
    selectors.language.sort((a, b) => {
      return compareStrings(a.name, b.name);
    });

    selectors.organisation = [];
    for (let i = 0; i < $session.api_config.organization_types.length; i++) {
      selectors.organisation.push({
        val: $session.api_config.organization_types[i],
        name: t9n($session.api_config.organization_types[i]),
      });
    }

    selectors.organisation.sort((a, b) => {
      return compareStrings(a.name, b.name);
    });

    selectors.worker_type = [
      {
        name: t9n('worker_type_self_employed'),
        val: 'worker_type_self_employed',
      },
      { name: t9n('worker_type_company'), val: 'worker_type_company' },
      { name: t9n('worker_type_other'), val: 'worker_type_other' },
    ];

    if (
      $session.user.worker_type === 'worker_type_employment' ||
      $session.merchant.default_worker_type === 'worker_type_employment'
    ) {
      selectors.worker_type.push({
        name: t9n('worker_type_employment'),
        val: 'worker_type_employment',
      });
    }

    if (
      $session.user.worker_type === null &&
      $session.merchant.default_worker_type === 'worker_type_employment'
    ) {
      input.worker_type = 'worker_type_employment';
    }
  };

  const validate_first_name = name => {
    let result = Validators.validate_first_name(name);
    validators.first_name = result.valid;
    input_errors.first_name = result.error;
  };

  const validate_last_name = name => {
    let result = Validators.validate_last_name(name);
    validators.last_name = result.valid;
    input_errors.last_name = result.error;
  };

  const validate_tax_amount = value => {
    let result = Validators.validate_tax_amount(value);
    validators.tax = result.valid;
    input_errors.tax = result.error;
  };

  const validate_linkedin = link => {
    let result = Validators.validate_linked_in_link(link);
    validators.linkedin = result.valid;
    input_errors.linkedin = result.error;
  };

  const validate_iban = iban => {
    let result = Validators.validate_iban(iban);
    validators.iban = result.valid;
    input_errors.iban = result.error;
  };

  const validate_password = async password => {
    let result = await Validators.verify_password(password);
    validators.password = result.valid;
    input_errors.password = result.error;
  };

  const validate_new_password = (pw, pw_confirm) => {
    let result = Validators.validate_password(pw, pw_confirm);
    validators.new_password = result.valid;
    input_errors.new_password;
  };

  const validate_new_password_confirm = (pw_confirm, pw) => {
    let result = Validators.validate_password(pw_confirm, pw);
    validators.new_password_confirm = result.valid;
    input_errors.new_password_confirm;
  };

  const validate_email = async email => {
    let result = await Validators.validate_email_settings(email, $session.user.email);
    validators.email = result.valid;
    input_errors.email = result.error;
  };

  const validate_organization_type = (org_type, org_type_clicked) => {
    // if(org_type_clicked){
      let result = Validators.validate_organization_type(org_type, $session.user.last_role, $session.user.is_orderer);
      validators.organization_type = result.valid;
      input_errors.organization_type = result.error;
    // }

  };

  const validate_company_name = company_name => {
    let result = Validators.validate_company_name(company_name, $session.user.last_role, input.organization.type, input.worker_type);
    validators.company_name = result.valid;
    input_errors.company_name = result.error;
  };

  const validate_reg_num = reg_num => {
    let result = Validators.validate_reg_num(reg_num, $session.user.last_role, input.worker_type, input.organization.type);
    validators.registration_number = result.valid;
    input_errors.registration_number = result.error;
  };

  const validate_video = video => {
      let result = Validators.validate_reg_num(video, first_validator.video);
      validators.video = result.valid;
      input_errors.video = result.error;
  };

  const validate_ssn = ssn => {
    let result = Validators.validate_ssn(ssn, first_validator.ssn, $session.merchant.country_code, $session.user.last_role);
    validators.ssn = result.valid;
    input_errors.ssn = result.error;
  };

  const open_change_password_dialog = () => {
    reset_form_state();
    dialog_change_password.open();
  };

  const close_change_password_dialog = () => {
    validators.password = true;
    validators.new_password = true;
    validators.new_password_confirm = true;
    dialog_change_password.close();
    reset_form_state();
  };

  const check_filled = () => {
    const TRUE = R.equals(true);
    const checks = [
      !!old_password && validators.password,
      !!new_password && validators.new_password,
      !!new_password_confirm && validators.new_password_confirm,
    ];

    return R.all(TRUE)(checks);
  };

  const reset_form_state = () => {
    old_password = null;
    new_password = null;
    new_password_confirm = null;
    change_password_disabled = true;
  };

  // event handler functions ------------------------------------------------- //

  const change_password = async () => {
    const data = {
      password_current: old_password,
      password_new: new_password,
    };
    reset_form_state();
    const result = await APIClient.change_password(data);

    if (!!result) {
      show_message(labels.success_message, 'success');
      close_change_password_dialog();
    }
  };

  // reactive functions  ------------------------------------------------------ //

  $: if (input.email) {
    clearTimeout(email_debounce_timer);
    const current_email = input.email;
    email_debounce_timer = setTimeout(() => {
      validate_email(current_email);
    }, VALIDATION_DEBOUNCE_MS);
  }

  $: if (!!old_password && old_password.length > 0) {
    clearTimeout(password_debounce_timer);
    const current_password = old_password;
    password_debounce_timer = setTimeout(() => {
      validate_password(current_password);
    }, VALIDATION_DEBOUNCE_MS);
  }

  $: if(!!new_password && new_password.length > 0) validate_new_password(new_password, new_password_confirm);
  $: if(!!new_password_confirm && new_password_confirm.length > 0) validate_new_password_confirm(new_password_confirm, new_password);
  $: validate_first_name(input.first_name);
  $: validate_last_name(input.last_name);

  $: validate_tax_amount(input.tax_amount);
  $: validate_iban(input.bank_account);
  $: validate_ssn(input.ssn);
  $: validate_video(input.video_link);
  $: validate_linkedin(input.linked_in_link);
  $: validate_company_name(input.organization.name);
  $: validate_reg_num(input.company_registration_number);
  $: validate_organization_type(input.organization.type, org_type_clicked);
  // $: if (!!$session.api_config && !!$session.api_config.phone_country_codes) set_country(input.phone.code);
  $: if (input.ssn) first_validator.ssn = false;
  $: if (input.video_link) first_validator.video = false;
  $: if (input.bank_account) first_validator.iban = false;
  $: if (!!$session.api_config && !!$session.api_config.supported_languages)
    init_selectors();
  load_country_codes();
  // $: if (!!$session.api_config) load_country_codes();
  $: if (!!settings.api_host && input.image_url && input.image_url[0] !== '/') {
    input.image_url = `${settings.api_host}${input.image_url}`;
  }

  $: if (!!$session) labels = ProfileInfo.translate_texts();

  $: {
    old_password;
    new_password;
    new_password_confirm;

    setTimeout(() => {
      change_password_disabled = !check_filled();
    }, 500);
  }

  let is_visible = false;
  $: if($session?.route === '/settings'){
    is_visible = true;
  } else{
    is_visible = false;
  }
  // initialization ----------------------------------------------------------- //

  onMount(init_profile_info);

  onDestroy(() => {
    clearTimeout(email_debounce_timer);
    clearTimeout(password_debounce_timer);
  });
</script>


{#if is_visible}
<div class='mdc-layout-grid mobile-margin'>
  <div class='mdc-layout-grid__inner'>
    <div class='mdc-layout-grid__cell--span-6'>
      <section id='overview-content' class='tab-content'>
        <b>{labels.edit_prof}: {$session.user.email}</b>

        <p />

        {#if !is_first_time}
        <div>
          <InputWithValidation
            id='first-name'
            variant={'filled'}
            type='text'
            is_required={true}
            margin_bottom={'0px'}
            label={labels.first_name}
            name='first-name'
            validate={false}
            bind:value={input.first_name}
            valid={validators.first_name}
            validation_text={input_errors.first_name}
            width='440px' />
        </div>

        <div>
          <InputWithValidation
            id='last-name'
            variant={'filled'}
            type='text'
            is_required={true}
            margin_bottom={'0px'}
            label={labels.last_name}
            name='last-name'
            validate={false}
            bind:value={input.last_name}
            valid={validators.last_name}
            validation_text={input_errors.last_name}
            width='440px' />
        </div>

        <div>
          <InputWithValidation
            id='email-address'
            type='text'
            is_required={true}
            label={t9n(TS.PROFILE_EMAIL_LABEL)}
            name='email-address'
            validate={false}
            variant={'filled'}
            bind:value={input.email}
            valid={validators.email}
            validation_text={input_errors.email}
            width='440px' />
        </div>

        {#if !!selectors.language}
          <div data-tooltip={t9n(TS.TOOLTIPS_SETTINGS_LANGUAGE)} style='width: 100%; max-width: 450px; margin-top: -13px;'>
            <Selector
              label={labels.select_language}
              id='selector_language'
              is_required={true}
              variant={'filled'}
              bind:value={input.language}
              items={selectors.language} />
          </div>
        {/if}

        <div style='margin-bottom: -15px;'>
          <PhoneNumberFieldSettings
            id='phone_number'
            bind:valid={validators.phone}
            bind:this={phone_field}
            bind:phone
            width='283px'/>
        </div>
        {/if}

        {#if $session.user.last_role === 'worker'}
          {#if !!selectors.worker_type}
            <div data-tooltip={t9n(TS.TOOLTIPS_SETTINGS_WORKER_TYPE)} style='width: 100%; max-width: 450px'>
              <Selector
                label={labels.worker_type}
                id='worker_type'
                is_required={true}
                variant={'filled'}
                bind:value={input.worker_type}
                items={selectors.worker_type} />
            </div>
            {#if input.worker_type !== 'worker_type_employment' && input.worker_type !== 'worker_type_self_employed'}
            <InputWithValidation
              id='comp-name'
              variant={'filled'}
              type='text'
              margin_bottom={'0px'}
              label={labels.company_name}
              name='comp-name'
              validate={false}
              bind:value={input.organization.name}
              valid={validators.company_name}
              validation_text={input_errors.company_name}
              disabled={input.worker_type === 'worker_type_self_employed'}
              width='440px' />
            {/if}

            {#if input.worker_type !== 'worker_type_employment' && input.worker_type !== 'worker_type_self_employed'}
              <InputWithValidation
                id='reg-num'
                data-cy='reg-num'
                variant={'filled'}
                type='text'
                is_required={true}
                margin_bottom={'0px'}
                label={labels.registration_number}
                name='comp-name'
                validate={false}
                bind:value={input.company_registration_number}
                valid={validators.registration_number}
                validation_text={input_errors.registration_number}
                disabled={input.worker_type === 'worker_type_self_employed'}
                width='440px' />
            {/if}
          {/if}
        {/if}

        <!-- Short description -->
        {#if $session.user.last_role === 'orderer'}
          <div data-tooltip={t9n(TS.TOOLTIPS_SETTINGS_ORDERER_DESC)}>
            <InputWithValidation
              id='task-description'
              type='tasks'
              label={labels.short_description}
              name='task'
              margin_bottom={'0px'}
              validate={false}
              valid={true}
              variant={'filled'}
              bind:value={input.short_description.orderer}
              width='440px'
              height='200px'
              filled_textarea_label={true}
            />
          </div>
        {:else}
          <div data-tooltip={t9n(TS.TOOLTIPS_SETTINGS_WORKER_DESC)}>
            <InputWithValidation
              id='task-description'
              type='tasks'
              label={labels.short_description}
              name='task'
              margin_bottom={'0px'}
              valid={true}
              variant={'filled'}
              bind:value={input.short_description.worker}
              width='440px'
              height='200px'
              filled_textarea_label={true}
            />
          </div>
        {/if}


        {#if $session.user.last_role === 'worker' && !is_first_time}
          <div style=''>
            <InputWithValidation
              id='video-pres'
              variant={'filled'}
              margin_bottom={'0px'}
              type='link'
              validation_text={input_errors.video}
              label={labels.video_presentation}
              name='video-pres'
              valid={validators.video || (!validators.video && input.video_link.length === 0)}
              validate={false}
              bind:value={input.video_link}
              width='440px' />
          </div>

          <div style=''>
            <InputWithValidation
              id='linkedin-link'
              variant={'filled'}
              margin_bottom={'0px'}
              type='link'
              validation_text={input_errors.linkedin}
              label={labels.linkedin_profile}
              name='linkedin-link'
              valid={validators.linkedin || (!validators.linkedin && input.linked_in_link.length === 0)}
              validate={false}
              bind:value={input.linked_in_link}
              width='440px' />
          </div>

          <div style=''>
            <InputWithValidation
              id='referee'
              data-cy='referee'
              variant={'filled'}
              type='text'
              margin_bottom={'0px'}
              label={labels.referee}
              name='referee'
              validate={false}
              bind:value={input.referee}
              width='440px' />
          </div>

          <div style='margin-top: 20px'>
            <CheckBox
              id='cv-public'
              bind:value={input.cv_is_public}
              label={labels.cv_public} />
            <br />
          </div>
        {/if}

        {#if $session.user.last_role === 'orderer'}
          {#if !!selectors.organisation}
            <div data-tooltip={t9n(TS.TOOLTIPS_SETTINGS_ORG_TYPE)} style='width: 100%; max-width: 450px;'>
              <Selector
                label={labels.organization_type}
                is_required={true}
                id='org-type'
                bind:has_focused={org_type_clicked}
                variant={'filled'}
                bind:value={input.organization.type}
                items={selectors.organisation} />
            </div>
          {/if}
          <InputWithValidation
            id='reg-num'
            variant={'filled'}
            margin_bottom={'0px'}
            type='text'
            is_required={true}
            validation_text={input_errors.registration_number}
            label={labels.registration_number}
            name='reg-num'
            valid={validators.registration_number}
            validate={false}
            disabled={input.organization.type === 'organization_type_private_person'}
            bind:value={input.company_registration_number}
            width='440px' />
          <InputWithValidation
            id='comp-name'
            variant={'filled'}
            margin_bottom={'0px'}
            type='text'
            validation_text={input_errors.company_name}
            label={labels.company_name}
            name='comp-name'
            valid={validators.company_name}
            validate={false}
            disabled={input.organization.type === 'organization_type_private_person'}
            bind:value={input.organization.name}
            width='440px' />
        {/if}

        <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>
        {#if !is_first_time}
        <div class='btn-delete'>
          <button
            id='change_button'
            on:click|stopPropagation|preventDefault={() => open_change_password_dialog()}
            style='margin-top: 10px;'
            class='mdc-button mdc-button--outlined'>
            <span class='mdc-button__ripple' />
            {labels.change_password}
          </button>

          <button
            on:click|stopPropagation|preventDefault={() => open_delete_dialog()}
            style='margin-top: 10px;'
            class='mdc-button mdc-button--outlined'>
            <span class='mdc-button__ripple' />
            {labels.delete_acc}
          </button>
        </div>
        {/if}

      </section>
    </div>

    <div class='mdc-layout-grid__cell--span-6 break-row-on-mobile'>
      <div class='settings-right'>
        {#if !has_pic_saved}
          {#if !!input.image_url}
            <img id='prof-img' src={input.image_url} />
          {:else}
            <img id='prof-img' src={default_image} />
          {/if}
        {:else if !!input.profile_picture}
          <img
            id='prof-img'
            src={`data:image/png;base64, ${input.profile_picture}`} />
        {:else}
          <img id='prof-img' src={default_image} />
        {/if}

        <button
          class='mdc-button mdc-button--outlined mdc-ripple-upgraded'
          id='open-file-uploader'
          on:click={() => open_dialog_pic()}
          style='margin-left: -40px; --mdc-ripple-fg-size:58px;
          --mdc-ripple-fg-scale:1.95932;
          --mdc-ripple-fg-translate-start:20.4336px, -12.4258px;
          --mdc-ripple-fg-translate-end:19.5938px, -11px;'>
          <span class='mdc-button__ripple' />
          <span class='mdc-button__label'>{labels.change_pic}</span>
        </button>
      </div>


      {#if $session.user.last_role === 'worker' && !is_first_time}
        <div class='bank-details'>
          <b class='title-margin'>{labels.payment_info}</b>
          <div style='display: flex; margin-top: 10px'>
            <InputWithValidation
              id='bank-acc'
              variant={'filled'}
              type='text'
              margin_bottom={'0px'}
              label={labels.bank_account_number}
              name='bank-acc'
              validate={false}
              bind:value={input.bank_account}
              valid={validators.iban}
              validation_text={input_errors.iban}
              width='370px' />
          </div>

          <div style='display: flex'>
            <InputWithValidation
              id='tax-amount'
              variant={'filled'}
              type='text'
              margin_bottom={'0px'}
              label={`${labels.tax} (0.0 - 100.0)`}
              name='tax-amount'
              validate={false}
              bind:value={input.tax_amount}
              valid={validators.tax}
              validation_text={input_errors.tax}
              width='370px' />
          </div>

          <div style='display: flex'>
            <InputWithValidation
              id='ssn-num'
              variant={'filled'}
              type='text'
              margin_bottom={'0px'}
              label={labels.ssn}
              name='ssn-num'
              validate={false}
              bind:value={input.ssn}
              valid={validators.ssn}
              validation_text={input_errors.ssn}
              width='370px' />
          </div>
        </div>
      {/if}

      {#if $session.tutorial}
        <div style='display: none'></div>
      {:else }
        <div class='response-center'>
          <button
            class='mdc-button mdc-button--outlined mdc-ripple-upgraded'
            id='rewatch_tutorial'
            on:click={async () => { await rewatch_tutorial() } }
            style=''>
            <span class='mdc-button__ripple' />
            <span class='mdc-button__label'>{labels.rewatch_tutorial}</span>
          </button>
        </div>
      {/if}
    </div>
  </div>
</div>

<div style='display: flex; justify-content: flex-end; position: relative;'>
  {#if is_valid}
    <button
      onclick='next_tab()'
      class='mdc-button mdc-button--unelevated'
      data-cy='next'>
      <span class='mdc-button__ripple' />
      {labels.btn_next}
    </button>
  {:else}
    <button disabled class='mdc-button mdc-button--unelevated' data-cy='next'>
      <span class='mdc-button__ripple' />
      {labels.btn_next}
    </button>
  {/if}

</div>
{/if}

<div class='pic-dialog' />
<input
  type='file'
  id='input-button'
  on:change={load_file}
  accept='image/*'
  style='display: none;' />

<div id='pic-dialog' class='mdc-dialog'>
  <div class='mdc-dialog__container'>
    <div
      class='mdc-dialog__surface'
      role='alertdialog'
      aria-modal='true'
      aria-labelledby='my-dialog-title'
      aria-describedby='my-dialog-content'>

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class='mdc-dialog__title' id='education-title'>
        {labels.dialog_label}
      </h2>

      <div class='mdc-dialog__content'>
        <!--                <img id="imgpreview2" width="600">-->
      </div>

      <footer class='mdc-dialog__actions'>

        <button
          on:click={() => open_upload_pic_dialog()}
          class='btn-close mdc-button mdc-button--unelevated'>
          <span class='mdc-button__ripple' />
          {labels.btn_upload}
        </button>
        <button
          on:click={() => rotate_left()}
          style='margin-left: 10px;'
          class='btn-close mdc-button mdc-button--unelevated'>
          <span class='mdc-button__ripple' />
          <span class='material-icons'>rotate_left</span>
        </button>
        <button
          on:click={() => rotate_right()}
          style='margin-left: 10px;'
          class='btn-close mdc-button mdc-button--unelevated'>
          <span class='mdc-button__ripple' />
          <span class='material-icons'>rotate_right</span>
        </button>

        <button
          on:click={() => close_dialog_pic()}
          data-cy='close_pic'
          style='margin-left: 10px;'
          class='btn-close mdc-button mdc-button--unelevated'>
          <span class='mdc-button__ripple' />
          {labels.btn_close}
        </button>

        <button
          on:click={() => save_profile_pic()}
          style='margin-left: 10px;'
          class='btn-close mdc-button mdc-button--unelevated'>
          <span class='mdc-button__ripple' />
          {labels.btn_update}
        </button>
      </footer>
    </div>
  </div>

  <div class='mdc-dialog__scrim' />
</div>

<div class='delete-acc-dialog' />

<div id='change-password-dialog' class='mdc-dialog'>
  <div class='mdc-dialog__container'>
    <div
      class='mdc-dialog__surface'
      role='alertdialog'
      aria-modal='true'
      aria-labelledby='my-dialog-title'
      aria-describedby='my-dialog-content'
      style='overflow: visible'>

      <div class='mdc-dialog__content'>

        <h2 class='mdc-dialog__title' style='text-align: center;'>
          {labels.change_password_title}
        </h2>

        <div class='margin-space' />

        <!-- Password field -->
        <InputWithValidation
          id='password'
          type='password'
          label={labels.old_password_label}
          leading_icon='security'
          trailing_icon='password'
          name='password'
          bind:value={old_password}
          valid={validators.password}
          validation_text={input_errors.password} />

        <!-- Password confirmation field -->

        <InputWithValidation
          id='new_password'
          type='password'
          label={labels.new_password_label}
          leading_icon='security'
          trailing_icon='password_confirm'
          name='new_password'
          bind:value={new_password}
          valid={validators.new_password}
          validation_text={input_errors.new_password} />

        <!-- Password confirmation field -->

        <InputWithValidation
          id='new_password-confirm'
          type='password'
          label={labels.confirm_password_label}
          leading_icon='security'
          trailing_icon='password_confirm'
          name='new_password_confirm'
          bind:value={new_password_confirm}
          valid={validators.new_password_confirm}
          validation_text={input_errors.new_password_confirm} />

        <!-- Save button -->
        <footer class='mdc-dialog__actions'>
          <button
            on:click|stopPropagation|preventDefault={close_change_password_dialog}
            style='margin-left: 10px;'
            data-cy='close'
            class='btn-close mdc-button mdc-button--unelevated'>
            <span class='mdc-button__ripple' />
            {labels.cancel_label}
          </button>
          <button
            on:click|preventDefault={async () => { await change_password()} }
            disabled={!!change_password_disabled}
            data-cy='change-password'
            style='margin-left: 10px;'
            class='btn-close mdc-button mdc-button--unelevated'>
            <span class='mdc-button__ripple' />
            {labels.change_password_label}
          </button>


        </footer>
      </div>
    </div>
  </div>

  <div class='mdc-dialog__scrim' />
</div>

<!-- Confirm message -->
<Messages />

<style type='text/scss'>
  .required{
    font-size: 10pt;
    margin-left: 7px;
    margin-bottom: 20px;
    color: #323232;
  }

  .changes-text {
    margin-top: 10px;
    margin-right: 10px;
    position: absolute;
    left: 25px;
    opacity: .5;
    font-size: 14px;
  }

  .btn-delete {
    position: relative;
    width: 440px;
  }

  .btn-delete .mdc-button:nth-child(1) {
    margin-right: 10px;
  }

  .btn-delete .mdc-button:nth-child(2) {
    position: absolute;
    right: 0;
  }

  .btn-delete .mdc-button--outlined:not(:disabled):nth-child(2) {
    border-color: var(--mdc-theme-error);
  }

  .btn-delete .mdc-button:not(:disabled):nth-child(2) {
    color: var(--mdc-theme-error);
  }

  .btn-delete .mdc-button:nth-child(2):hover {
    background-color: #fff9fa;
  }

  .btn-delete .mdc-button:nth-child(2):focus {
    background-color: #ffeaed;
  }

  #prof-img {
    width: 200px;
    border-radius: 50%;
    margin-bottom: 15px;
    margin-left: 20%;
  }

  p {
    margin-bottom: -5px;
  }

  .material-icons.md-48 {
    font-size: 48px;
  }

  .material-icons.md-168 {
    font-size: 168px;
  }

  img {
    display: block !important;

    /* This rule is very important, please don't ignore this */
    max-width: 100% !important;
    overflow: hidden !important;
  }

  .margin-space {
    margin-top: 20px;
  }

  .bank-details {
    margin-top: 50px;
    margin-left: 50px;
  }

  .settings-right {
    margin-left: 50px;
    margin-top: 10px;
    align-content: center;
    text-align: center;
  }

  .title-margin {
    /*        margin-left: -225px;*/
  }

  /* todo: clean-up these media queries: */

  @media (min-width: 592px) {
    .mdc-dialog .mdc-dialog__surface {
      max-width: 800px;
    }
  }

  @media (max-width: 1024px) {
    .settings-right {
      margin-left: 0px;
    }

    .break-row-on-mobile {
      grid-column-start: 1;
    }

    .title-margin {
      margin-left: 0px;
    }

    .bank-details {
      text-align: left;
      margin-left: 0;
    }
  }

  /* Desktop Mode
        *******************************************************/
  @media (min-width: 1025px) {
    .response-center {
      text-align: center;
      margin-top: 25px;
      margin-left: 15px;
    }
  }

  /* Tablet Mode
        *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .response-center {
      text-align: center;
      margin-top: 25px;
      margin-left: 15px;
    }
  }

  /* Mobile Mode
        *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .response-center {
      text-align: center;
      margin-left: -20px;
      margin-top: 25px;
    }

    .mobile-margin {
      margin-left: 25px;
    }

    .btn-delete {
      display: flex;
      width: auto;
    }

    .btn-delete .mdc-button:nth-child(2) {
      position: unset;
    }

  }
</style>
